/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Crazy_Grebe_PraiseInputs */

const en_kind_crazy_grebe_praise = /** @type {(inputs: Kind_Crazy_Grebe_PraiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Kind_Crazy_Grebe_PraiseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const kind_crazy_grebe_praise = /** @type {((inputs?: Kind_Crazy_Grebe_PraiseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Crazy_Grebe_PraiseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_kind_crazy_grebe_praise(inputs)
});